import React, {Fragment,useEffect,useId,useRef,useState} from 'react'

import axios from 'axios'
import Btn from '../ui/Btn'
import './settings.css'

/*
 * Photo uploader used inside the challenge / sponsor forms.
 *
 * Contract unchanged: <FileUpload id type Photo loadData record/>.
 *   type 1 (or 0) -> admin/upload           — the main photo
 *   type 2        -> admin/upload/sponsors  — the sponsor logo
 * The preview reads admin/files/{id}/{t} and the delete hits admin/upload/{id}.
 *
 * Only the surface changed: token-styled controls, a real progress bar, and
 * inline messages plus a two-step confirm instead of alert() / window.confirm().
 */

const IconPaperclip=()=>(
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M21 11.5 12.5 20a5 5 0 0 1-7-7l8-8a3.5 3.5 0 0 1 5 5l-8 8a2 2 0 0 1-3-3l7.5-7.5"/>
  </svg>
)

const FileUpload = (props) => {

    const [file,setFile]=useState('')
    const [fileName,setFileName]=useState('Please select an image file')
    const [upLoading, setUpLoading]=useState(false)
    const [uploadPercentage, setUploadPercentage]=useState(0)
    const [url,setUrl]=useState('')
    const [title,setTitle]=useState('')
    const [photo,setPhoto]=useState('')
    /* the preview 404s until something has been uploaded — not an error */
    const [broken,setBroken]=useState(false)
    const [note,setNote]=useState(null)
    const [askDelete,setAskDelete]=useState(false)

    const inputRef=useRef(null)
    const inputId='st-upf-'+useId()

    useEffect(() => {

        loadFile(props.id)

        if (props.type==1){
            setUrl(process.env.REACT_APP_API_SERVER+'admin/upload')
            setFileName('Please select an image file')
            setTitle('Upload  Photo.')
        }

        if (props.type==2){
            setUrl(process.env.REACT_APP_API_SERVER+'admin/upload/sponsors')
            setFileName('Please select an image file')
            setTitle('Upload  Photo.')
        }

    }, [props.type])

    useEffect(()=>{
        loadFile(props.id)
    },[props.id])

    const resetPicker=()=>{
        if (inputRef.current) inputRef.current.value=null
        setFile('')
        setFileName('Please select an image file')
    }

    const fileChanged=e=>{
        setNote(null)
        const picked=e.target.files && e.target.files[0]
        if (!picked){
            resetPicker()
            return
        }

        if (props.type==1 || props.type==0 || props.type==2){
            if (String(picked.type||'').indexOf('image/')>-1){
                setFile(picked)
                setFileName(picked.name)
            }else{
                resetPicker()
                setNote({tone:'crit',text:'Please Select an IMAGE file'})
            }
        }
    }

    const uploadFile=async e=>{
        e.preventDefault()
        setNote(null)
        const formData=new FormData()
        formData.append('file',file)
        formData.append('id',props.id)
        try{
            setUpLoading(true)
            axios.post(url,formData,{
                headers:{
                    'Content-Type':'multipart/form-data',
                    'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
                },
                onUploadProgress: ProgressEvent=>{
                    setUploadPercentage(parseInt(Math.round(ProgressEvent.loaded*100/ProgressEvent.total)))
                }
            }).then(res=>{
                setUpLoading(false)
                resetPicker()

                setUploadPercentage(0)

                if (res.data.err==0){
                    props.loadData(props.id)
                    loadFile(props.id)
                    setNote({tone:'good',text:'Η φωτογραφία ανέβηκε.'})
                }else{
                    setNote({tone:'crit',text:'An Error has occured! Please Try Again'})
                }

            }).catch(err=>{
                setUpLoading(false)
                setUploadPercentage(0)
                setNote({tone:'crit',text:'Το ανέβασμα απέτυχε. Δοκιμάστε ξανά.'})
                console.log(err)
            })

        }catch(err){
            setUpLoading(false)
            setUploadPercentage(0)
            setNote({tone:'crit',text:'Το ανέβασμα απέτυχε. Δοκιμάστε ξανά.'})
            console.log(err)
        }
    }

    const loadFile=(id)=>{
            const t=Date.now()
            setBroken(false)
            setPhoto(process.env.REACT_APP_API_SERVER+'admin/files/'+id+'/'+t)
    }

    const delFile=()=>{
            axios.delete(process.env.REACT_APP_API_SERVER+'admin/upload/'+props.id,{
                headers:{
                    'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
                }
            }).then(res=>{
                setAskDelete(false)
                props.loadData(props.id)
                loadFile(props.id)
            }).catch(err=>{
                setAskDelete(false)
                setNote({tone:'crit',text:'Η διαγραφή απέτυχε. Δοκιμάστε ξανά.'})
                console.log(err)
            })
    }

    const hasPhoto=!!(props.record && props.record.Photo)

    return (

        <Fragment>
          <div className="st-up">

            <div className="st-up-head">
              <span className="mono st-up-title">{title}</span>
              <span className="st-up-sub">JPG ή PNG. Αντικαθιστά την τρέχουσα εικόνα.</span>
            </div>

            {note
              ? <div className="st-note" data-tone={note.tone} role="alert">
                  <span className="st-note-text">{note.text}</span>
                </div>
              : null}

            <form className="st-up-form" onSubmit={uploadFile}>
              <div className="st-file-row">
                <input
                  ref={inputRef}
                  className="st-file"
                  required
                  onChange={fileChanged}
                  type="file"
                  accept="image/*"
                  id={inputId}
                />
                <label className="st-file-label" htmlFor={inputId}>
                  <IconPaperclip/>
                  Επιλογή αρχείου
                </label>
                <span className="st-file-name" data-set={file ? '1' : '0'}>{fileName}</span>
              </div>

              {upLoading
                ? <div>
                    <div className="st-up-progress">
                      <span className="st-up-fill" style={{width:uploadPercentage+'%'}}></span>
                    </div>
                    <div className="st-up-pct">
                      <b>{uploadPercentage}%</b>
                      <span>Ανέβασμα — περιμένετε.</span>
                    </div>
                  </div>
                : null}

              <div className="st-up-actions">
                <Btn variant="accent" type="submit" disabled={upLoading}>
                  Upload {props.type==1 || props.type==0 ? ' Main Photo' :  'Sponsor Logo'}
                </Btn>
              </div>
            </form>

            {hasPhoto
              ? <div className="st-up-media">
                  {broken
                    ? <span className="st-hint">Η εικόνα δεν φορτώθηκε.</span>
                    : <img
                        className="st-up-img"
                        src={photo}
                        alt=""
                        onError={()=>setBroken(true)}
                      />}

                  {askDelete
                    ? <div className="st-confirm" role="alert">
                        <span className="st-confirm-t">Θα διαγραφεί η εικόνα.</span>
                        <span className="st-confirm-a">
                          <Btn onClick={()=>setAskDelete(false)}>Άκυρο</Btn>
                          <Btn className="st-crit" onClick={delFile}>Διαγραφή</Btn>
                        </span>
                      </div>
                    : <Btn className="st-crit" onClick={()=>setAskDelete(true)}>Διαγραφή εικόνας</Btn>}
                </div>
              : null}

          </div>
        </Fragment>
    )

}

export default FileUpload;
